import React, { Component } from 'react';
import { Card, Row, Table } from 'antd';
import { connect } from 'react-redux';
import util from '@util';
import '../expenses.less';
import moment from 'moment';
import DescriptionList from '@comm/DescriptionList';
import { queryFilePreview } from '@api/pub/attachment';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {
    this.setState({
      dataItem: this.props.data,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  columns = () => {
    return [
      {
        title: '采购物品',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '型号',
        dataIndex: 'model',
        key: 'model',
      },
      {
        title: '单价(元)',
        dataIndex: 'unit',
        key: 'unit',
        render: text => {
          return util.numberFormat(text);
        },
      },
      {
        title: '数量',
        dataIndex: 'count',
        key: 'count',
      },
    ];
  };

  render() {
    const { dataItem } = this.state;
    const files = dataItem.files || [];

    return (
      <div className="form-open">
        <Card title="采购详情">
          <DescriptionList size="large" col={3}>
            <Description term="申请人员">{dataItem.createUserName}</Description>
            <Description term="交付时间">
              {moment.unix(dataItem.expectedDate / 1000).format('YYYY-MM-DD')}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="采购凭证">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.url}>
                      <a onClick={() => queryFilePreview(item)}>{item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="采购说明">{dataItem.reason}</Description>
          </DescriptionList>
          <Row style={{ height: '30px', fontWeight: 'bold', paddingTop: '10px' }}>物品详情:</Row>
          <Table columns={this.columns()} dataSource={dataItem.details} pagination={false} />
          <p style={{ marginTop: '10px' }}>合计：{util.numberFormat(dataItem.price)}元</p>
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/FormOpen.js